module.exports = __webpack_public_path__ + "img/slide5.65b5350a.png";